<template>
  <div class="principal-hoja-prueba" data-app>
    <titulo-seccion titulo="DATA VERIFICATION"></titulo-seccion>
    <div class="container contenedor-hoja-prueba">
      <div class="row row-cols-lg-12 mt-3">
        <strong class="titulo-seccion">Data verification</strong>
        <p class="parrafo-instrucciones mt-2">
          You must verify correctly each one of the fields, since it is
          necessary that each one of them, are correct, they are editable fields
          so you can modify them to correct or change them.
        </p>
      </div>
      <form
        class="requiere-validacion"
        novalidate
        ref="formularioConfirmacionDatosBasicos"
        v-bind:class="{ 'was-validated': formularioValidadoDatosBasicos }"
      >
        <div class="row row-cols-lg-12">
          <div class="col-lg-6 campo-solicitud">
            <label class="form-label label-hoja-prueba">Given Name(s)</label>
            <input
              id="nombre"
              type="text"
              class="form-control campo-basico"
              placeholder="Given Name(s) *"
              v-model="datosBasicos.nombres"
              required
            />
            <div
              class="invalid-feedback"
              style="text-align: left; font-family: 'Poppins'"
            >
              Name is required.
            </div>
          </div>
          <div class="col-lg-6 campo-solicitud">
            <label class="form-label label-hoja-prueba">Middle name</label>
            <input
              type="text"
              class="form-control campo-basico"
              placeholder="Middle name"
              v-model="datosBasicos.apellidoMaterno"
            />
          </div>
        </div>
        <div class="row row-cols-lg-12">
          <div class="col-lg-6 campo-solicitud">
            <label class="form-label label-hoja-prueba"
              >Surname or family name</label
            >
            <input
              type="text"
              class="form-control campo-basico"
              placeholder="Surname or family name *"
              v-model="datosBasicos.apellidoPaterno"
              required
            />
            <div
              class="invalid-feedback"
              style="text-align: left; font-family: 'Poppins'"
            >
              Surname or family name is required.
            </div>
          </div>
          <div class="col-lg-6 campo-solicitud">
            <label class="form-label label-hoja-prueba">Amount</label>
            <VueAutonumeric
              class="form-control campo-basico"
              :options="{
                currencySymbol: '$',
                decimalPlaces: '2',
                minimumValue: '0',
                maximumValue: '15000000',
              }"
              :placeholder="'Monto'"
              v-model="datosBasicos.monto"
              disabled
            ></VueAutonumeric>
          </div>
        </div>
        <div class="row row-cols-lg-12">
          <div class="col-lg-6 campo-solicitud">
            <label class="form-label label-hoja-prueba">Service</label>
            <DropDown
              :disabled="this.soloLectura"
              placeholder="Select a service * "
              :arreglo="this.catalogos.servicios"
              llave="value"
              valor="value"
              texto="text"
              v-model="datosSolicitud.servicio"
            ></DropDown>
            <div
              class="invalid-feedback"
              style="text-align: left; font-family: 'Poppins'"
            >
              Please select a service.
            </div>
          </div>
        </div>
        <div class="row row-cols-lg-12 mt-4">
          <label
            class="form-label label-hoja-prueba"
            style="text-align: initial"
            >Personal Address:</label
          >
          <div class="col-lg-6">
            <input
              :disabled="this.soloLectura"
              placeholder="Street *"
              type="text"
              class="form-control campo-basico"
              v-model="DatosUbicacionGeneralParticular.calle"
              required
            />
            <div
              class="invalid-feedback"
              style="text-align: left; font-family: 'Poppins'"
            >
              Street is required.
            </div>
          </div>
          <div class="col-lg-6">
            <input
              :disabled="this.soloLectura"
              placeholder="Number *"
              type="text"
              min="0"
              class="form-control campo-basico"
              v-model="DatosUbicacionGeneralParticular.numero"
              required
            />
            <div
              class="invalid-feedback"
              style="text-align: left; font-family: 'Poppins'"
            >
              Number is required.
            </div>
          </div>
        </div>
        <div class="row row-cols-lg-12">
          <div class="col-lg-6">
            <input
              placeholder="Zip Code *"
              :disabled="this.soloLectura"
              type="text"
              min="0"
              class="form-control campo-basico"
              v-model="DatosUbicacionParticular.codigoPostal"
              pattern="^[ A-Za-z0-9_@./#&+-]{1,10}$"
            />
            <div
              class="invalid-feedback"
              style="text-align: left; font-family: 'Poppins'"
            >
              Zip Code is required.
            </div>
          </div>
          <div class="col-lg-6">
            <input
              placeholder="Suburb/Town *"
              :disabled="this.soloLectura"
              type="text"
              class="form-control campo-basico"
              v-model="DatosUbicacionParticular.ciudad"
              required
            />
            <div
              class="invalid-feedback"
              style="text-align: left; font-family: 'Poppins'"
            >
              Suburb/Town is required.
            </div>
          </div>
        </div>
        <div class="row row-cols-lg-12">
          <div class="col-lg-6">
            <input
              placeholder="State *"
              :disabled="this.soloLectura"
              type="text"
              class="form-control campo-basico"
              v-model="DatosUbicacionParticular.estado"
              required
            />
            <div
              class="invalid-feedback"
              style="text-align: left; font-family: 'Poppins'"
            >
              State is required.
            </div>
          </div>
          <div class="col-lg-6">
            <DropDown
              :disabled="this.soloLectura"
              placeholder="Country *"
              :arreglo="this.catalogos.paises"
              llave="paisId"
              valor="paisId"
              texto="descripcionIngles"
              :requerido="true"
              v-model="DatosUbicacionParticular.paisId"
            ></DropDown>
            <div
              class="invalid-feedback"
              style="text-align: left; font-family: 'Poppins'"
            >
              Country is required.
            </div>
          </div>
        </div>
        <div v-if="DatosUbicacionGeneralOficina.ubicacionId != 0">
          <div class="row row-cols-lg-12 mt-4">
            <label
              class="form-label label-hoja-prueba"
              style="text-align: initial"
              >Work address:</label
            >
            <div class="col-lg-6">
              <input
                placeholder="Company address (Street)"
                :disabled="this.soloLectura"
                type="text"
                class="form-control campo-basico"
                v-model="DatosUbicacionGeneralOficina.calle"
                required
              />
              <div
                class="invalid-feedback"
                style="text-align: left; font-family: 'Poppins'"
              >
                Street is required.
              </div>
            </div>
            <div class="col-lg-6">
              <input
                placeholder="Company address (Number)"
                :disabled="this.soloLectura"
                type="text"
                class="form-control campo-basico"
                v-model="DatosUbicacionGeneralOficina.numero"
                required
              />
              <div
                class="invalid-feedback"
                style="text-align: left; font-family: 'Poppins'"
              >
                Number is required.
              </div>
            </div>
          </div>
          <div class="row row-cols-lg-12">
            <div class="col-lg-6">
              <input
                placeholder="Zip Code"
                :disabled="this.soloLectura"
                type="text"
                min="0"
                class="form-control campo-basico"
                v-model="DatosUbicacionOficina.codigoPostal"
                pattern="^[ A-Za-z0-9_@./#&+-]{1,10}$"
              />
              <div
                class="invalid-feedback"
                style="text-align: left; font-family: 'Poppins'"
              >
                Zp Code is required
              </div>
            </div>
            <div class="col-lg-6">
              <input
                placeholder="Suburb/Town"
                :disabled="this.soloLectura"
                v-model="DatosUbicacionOficina.ciudad"
                type="text"
                class="form-control campo-basico"
                required
              />
              <div
                class="invalid-feedback"
                style="text-align: left; font-family: 'Poppins'"
              >
                Suburb/Town is required
              </div>
            </div>
          </div>
          <div class="row row-cols-lg-12">
            <div class="col-lg-6">
              <input
                placeholder="State"
                :disabled="this.soloLectura"
                v-model="DatosUbicacionOficina.estado"
                type="text"
                class="form-control campo-basico"
              />
              <div
                class="invalid-feedback"
                style="text-align: left; font-family: 'Poppins'"
              >
                State is required
              </div>
            </div>
            <div class="col-lg-6">
              <DropDown
                :disabled="this.soloLectura"
                placeholder="Select a country"
                :arreglo="this.catalogos.paises"
                llave="paisId"
                valor="paisId"
                texto="descripcionIngles"
                v-model="DatosUbicacionOficina.paisId"
                :requerido="true"
              ></DropDown>
              <div
                class="invalid-feedback"
                style="text-align: left; font-family: 'Poppins'"
              >
                Country is required
              </div>
            </div>
          </div>
        </div>
        <div class="row row-cols-lg-12">
          <div
            class="col-lg-6 campo-solicitud"
            style="display: flex; flex-direction: column"
          >
            <label
              class="form-label label-hoja-prueba"
              style="text-align: initial"
              >Date of birth</label
            >
            <input-fecha
              idioma="es-MX"
              v-model="datosSolicitud.fechaNacimiento"
            ></input-fecha>
          </div>
          <div class="col-lg-6 campo-solicitud">
            <label class="form-label label-hoja-prueba">Phone</label>
            <input
              style="height: 48px"
              :disabled="this.soloLectura"
              placeholder="Phone (10 digits)"
              type="number"
              onkeydown="return event.keyCode !== 69"
              min="0"
              class="form-control campo-basico"
              v-model="PuntoContactoGeneral.telefonoFijo.valor"
            />
          </div>
        </div>
        <div class="row row-cols-lg-12">
          <div class="col-lg-6 campo-solicitud">
            <label class="form-label label-hoja-prueba">Work phone</label>
            <input
              :disabled="this.soloLectura"
              placeholder="Work Phone "
              type="number"
              onkeydown="return event.keyCode !== 69"
              min="0"
              class="form-control campo-basico"
              v-model="PuntoContactoGeneral.telefonoFijoOficina.valor"
            />
          </div>
          <div class="col-lg-6 campo-solicitud">
            <label class="form-label label-hoja-prueba">Email</label>
            <input
              placeholder="Email *"
              type="email"
              class="form-control campo-basico"
              v-model="PuntoContactoGeneral.correo1.valor"
              disabled
            />
          </div>
        </div>
        <button
          ref="envioFormularioDatosBasicos"
          @click.prevent="ValidaFormulario"
          class="btn btn-primary"
          hidden
          type="submit"
        >
          submit
        </button>
      </form>
      <div class="row row-cols-lg-12 mt-4">
        <label class="form-label label-hoja-prueba" style="text-align: initial"
          >Beneficiaries:</label
        >
        <div
          v-for="(formBeneficiario, index) in FormBeneficiarios"
          v-bind:key="index"
        >
          <form novalidate>
            <div class="row row-cols-lg-12">
              <div class="col-lg-6 campo-solicitud">
                <input
                  :disabled="soloLectura"
                  type="text"
                  placeholder="Given Name(s) *"
                  class="form-control campo-basico"
                  v-model="formBeneficiario.nombre"
                  required
                />
              </div>
              <div class="col-lg-6 campo-solicitud">
                <input
                  :disabled="soloLectura"
                  type="text"
                  placeholder="Middle name"
                  v-model="formBeneficiario.apellidoMaterno"
                  class="form-control campo-basico"
                />
              </div>
            </div>
            <div class="row row-cols-lg-12 row-ap-materno-benfeficiario">
              <div class="col-lg-6 campo-solicitud">
                <input
                  :disabled="soloLectura"
                  type="text"
                  placeholder="Surname or family name *"
                  v-model="formBeneficiario.apellidoPaterno"
                  class="form-control campo-basico"
                  required
                />
              </div>
              <div class="col-lg-6 campo-solicitud">
                <DropDown
                  :disabled="soloLectura"
                  placeholder="Type of relationship *"
                  :arreglo="catalogos.parentescos"
                  llave="value"
                  valor="value"
                  texto="text"
                  v-model="formBeneficiario.parentesco"
                  :requerido="true"
                ></DropDown>
              </div>
            </div>
            <div class="row row-cols-lg-12 row-ap-materno-benfeficiario">
              <div class="col-lg-6 campo-solicitud">
                <div class="input-group">
                  <input
                    :disabled="soloLectura"
                    @keyup="LimitarPorcentaje(index)"
                    type="number"
                    onkeydown="return event.keyCode !== 69"
                    min="0"
                    class="form-control campo-basico"
                    v-model="formBeneficiario.porcentaje"
                    placeholder="Porcentaje *"
                    required
                  />
                  <div class="input-group-prepend">
                    <span
                      class="input-group-text"
                      style="
                        border-radius: 0px;
                        border: 1px solid;
                        font-family: 'Poppins';
                      "
                      >%</span
                    >
                  </div>
                </div>
              </div>
              <div class="col-lg-6 campo-solicitud">
                <input
                  :disabled="soloLectura"
                  type="number"
                  onkeydown="return event.keyCode !== 69"
                  min="0"
                  placeholder="Teléfono móvil (10 dígitos)*"
                  v-model="formBeneficiario.telefono"
                  class="form-control campo-basico"
                  required
                />
              </div>
            </div>
            <div
              class="col-lg-12 col-sm-12"
              style="text-align: end"
              v-if="soloLectura == false"
            >
              <strong
                v-if="
                  FormBeneficiarios.length > 1 &&
                    CamposActualesVacios(index) == false
                "
                class="etiqueta-nuevo-documento"
                @click.prevent="EliminarBeneficiarioTest(index)"
                >Delete beneficiarie</strong
              >
            </div>
          </form>
        </div>
        <div
          class="col-lg-12 col-sm-12 col-agregar-beneficiario"
          style="text-align: end"
        >
          <label
            class="etiqueta-nuevo-documento"
            @click.prevent="AgregarFormBeneficiario(true)"
            >Add another beneficiarie</label
          >
        </div>
        <div class="row row-cols-lg-12 row-confirmar" v-if="PuedeAprobar">
          <button
            v-if="confirmandoDatos"
            type="button"
            disabled
            class="boton-primario boton-confirmar"
          >
            <v-progress-circular
              indeterminate
              size="30"
              color="primary"
            ></v-progress-circular>
          </button>
          <button
            v-else-if="!confirmandoDatos"
            type="button"
            class="boton-primario boton-confirmar"
            @click.prevent="ConfirmarInformacion()"
          >
            Confirm
          </button>
          <button
            v-else
            type="button"
            :disabled="true"
            class="boton-primario boton-confirmar"
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//Plugins
import axios from "axios";
//import servicios from '../../../servicios/service.js';
//Componentes
import TituloSeccion from "../../../Componentes/TituloSeccion.vue";
import VueAutonumeric from "../../../../../../node_modules/vue-autonumeric/src/components/VueAutonumeric.vue";
import DropDown from "../components/DropDown.vue";
import InputFecha from "../components/InputFecha.vue";
//Mixins
import mixinHojaPrueba from "../Mixins/MixinHojaPrueba.js";
import mixinSolicitudInscripcion from "../Mixins/MixinSolicitudInscripcion.js";
const rutaEnviarACore = "/api/Master/PreAutorizacion/EnviarACore";
const rutaEnviarACoreAdicionales =
  "/api/Master/PreAutorizacion/EnviarACoreAdicionales";
const rutaObtenerFiguraAdicional =
  "/api/Master/FiguraAdicional/ListarFiguraAdicional";

export default {
  name: "HojaPruebaExtranjero",
  components: {
    TituloSeccion,
    VueAutonumeric,
    DropDown,
    InputFecha,
  },
  mixins: [mixinHojaPrueba, mixinSolicitudInscripcion],
  mounted() {
    this.ProspectoId = this.$store.getters.prospectoId;
    this.tipoPersona = this.$store.getters.tipoPersona;
    this.tipoUsuario = this.$store.getters.tipoUsuario;

    if (this.$store.getters.modoPago == 2) {
      this.modoPago = 2;
    } else {
      this.modoPago = 1;
    }
    if (this.tipoUsuario == 3 || this.tipoUsuario == 8) {
      this.esProspecto = true;
    }

    this.ValidarAprobadoresHojaPrueba(this.tipoUsuario);

    this.CargarServicios(true);
    this.CargarParentescos(true);
    this.CargarPaises(true);
    //Carga de datos de la hoja de prueba
    this.CargarDatosHojaPrueba(this.ProspectoId, this.tipoPersona);
    //this.ConsultarSolicitudes(this.ProspectoId, false);
    this.ListarFigurasAdicionales(this.ProspectoId, this.tipoPersona);
  },
  data() {
    return {
      PuedeAprobar: false,
      ProspectoId: null,
      SolicitudId: null,
      tipoPersona: null,
      tipoUsuario: null,
      solicitudExistenteId: null,
      tieneAdicionales: false,
      adicionalesEnviadosCore: 0,
      figuras: [],
      catalogos: {
        servicios: [],
        colonias: [],
        coloniasEmpresa: [],
        coloniasFactura: [],
        paises: [],
      },
      //Datos basicos
      datosBasicos: {
        nombres: null,
        apellidoPaterno: null,
        apellidoMaterno: null,
        monto: null,
      },
      datosSolicitud: {
        solicitudId: null,
        fechaNacimiento: null,
        servicio: null,
      },
      datosSolicitudFisica: {
        rfc: null,
      },
      PuntoContactoGeneral: {
        telefonoFijo: {
          puntoContactoId: 0,
          valor: null,
        },
        telefonoMovil: {
          puntoContactoId: 0,
          valor: null,
        },
        correo1: {
          puntoContactoId: 0,
          valor: null,
        },
        correo2: {
          puntoContactoId: 0,
          valor: null,
        },
        telefonoFijoOficina: {
          puntoContactoId: 0,
          valor: null,
        },
      },
      DatosUbicacionGeneralParticular: {
        ubicacionId: 0,
        prospectoId: null,
        tipoUbicacion: 0,
        calle: null,
        numero: null,
      },
      DatosUbicacionGeneralOficina: {
        ubicacionId: 0,
        prospectoId: null,
        tipoUbicacion: 1,
        calle: null,
        numero: null,
      },
      DatosUbicacionParticular: {
        ubicacionId: null,
        paisId: null,
        estado: null,
        ciudad: null,
        codigoPostal: null,
      },
      DatosUbicacionOficina: {
        ubicacionId: null,
        paisId: null,
        estado: null,
        ciudad: null,
        codigoPostal: null,
      },
      FormBeneficiarios: [
        {
          beneficiarioId: null,
          nombre: null,
          apellidoPaterno: null,
          apellidoMaterno: null,
          parentesco: null,
          porcentaje: null,
          telefono: null,
        },
      ],
      formularioValidadoDatosBasicos: false,
      confirmandoDatos: false,
      soloLectura: false,
      modoPago: null,
      esProspecto: false,
    };
  },
  computed: {
    camposVaciosBeneficiarioForm: function() {
      let llaves = Object.keys(
        this.FormBeneficiarios[this.FormBeneficiarios.length - 1]
      );
      let vacios = 0;
      llaves.forEach((llave) => {
        if (llave != "apellidoMaterno" && llave != "beneficiarioId") {
          if (
            this.FormBeneficiarios[this.FormBeneficiarios.length - 1][llave] ===
              "" ||
            this.FormBeneficiarios[this.FormBeneficiarios.length - 1][llave] ===
              null
          ) {
            vacios++;
          }
        }
      });
      return vacios > 0 ? true : false;
    },
  },
  methods: {
    LimitarPorcentaje(index) {
      if (this.FormBeneficiarios.length == 1) {
        if (this.FormBeneficiarios[0].porcentaje > 100) {
          this.FormBeneficiarios[0].porcentaje = 100;
        }
      } else {
        if (this.SumaPorcentajes() > 100) {
          let resta =
            this.SumaPorcentajes() - this.FormBeneficiarios[index].porcentaje;
          let faltante = 100 - resta;
          this.FormBeneficiarios[index].porcentaje = faltante;
        }
      }
    },
    ConfirmarInformacion() {
      if (this.PuedeAprobar === false) {
        return;
      }
      this.$fire({
        title: "Confirmation",
        html:
          "I confirm that I have read and verified that the data shown are correct. <br>I authorize that with this data, the contracts are generated.",
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText: "Confirm",
        cancelButtonText: "Back",
      }).then((result) => {
        if (result.value) {
          this.$refs.envioFormularioDatosBasicos.click();
        }
      });
    },
    async ValidaFormulario() {
      let esValidoDatosBasicos = false;
      this.formularioValidadoDatosBasicos = true;
      esValidoDatosBasicos = this.$refs.formularioConfirmacionDatosBasicos.checkValidity();

      if (esValidoDatosBasicos) {
        this.confirmandoDatos = true;
        if (this.datosSolicitud.fechaNacimiento == null) {
          this.AlertaEmbajadores(
            "Please indicate your date of birth.",
            true,
            true
          );
          return;
        }
        if (this.FormBeneficiarios.length <= 0) {
          this.AlertaEmbajadores(
            "You must enter at least one beneficiary.",
            true,
            true
          );
          return;
        } else {
          if (this.SumaPorcentajes() < 100) {
            this.AlertaEmbajadores(
              "Beneficiaries must complete 100%.",
              true,
              true
            );
            return;
          }
        }

        this.ActualizarDatosBasicos();
        this.GuardarUbicacionGeneralParticular(true);
        if (
          this.DatosUbicacionGeneralOficina.ubicacionId != 0 &&
          this.DatosUbicacionGeneralOficina.ubicacionId != null
        ) {
          this.GuardarUbicacionGeneralOficina();
        }
        this.GuardarPuntosDeContacto(true, false);
        if (this.FormBeneficiarios.length > 0) {
          this.GuardarBeneficiariosTest(this.datosSolicitud.solicitudId);
        }
        this.$fire({
          title:
            //this.$store.getters.modoPago == 2
            this.modoPago == 2
              ? "Your data has been successfully confirmed, you will be redirected to your golden box."
              : "Your information has been successfully confirmed, we will validate your proof of payment.",
          showConfirmButton: true,
          showCancelButton: false,
          confirmButtonText: "Accept",
          allowOutsideClick: false,
        }).then(async (result) => {
          if (result.value) {
            if (this.modoPago == 2) {
              await this.EnviarACore();
            } else {
              await this.EnviarACore();
            }
          }
        });
      } else {
        this.confirmandoDatos = false;
      }
    },
    ListarFigurasAdicionales(prospectoId, tipoPersona) {
      const parametroProspecto = {
        params: {
          prospectoId: prospectoId,
          tipoPersona: tipoPersona,
        },
      };
      axios
        .get(rutaObtenerFiguraAdicional, parametroProspecto)
        .then((resp) => {
          if (resp.data.estado === 0) {
            this.figuras = resp.data.data;
            if (this.figuras.length > 0) {
              this.tieneAdicionales = true;
            }
          } else if (resp.data.estado === 1) {
            this.AlertaEmbajadores(resp.data.mensaje, true, true);
          } else {
            this.AlertaEmbajadores(resp.data.mensaje, true, true);
          }
        })
        .catch((e) => {
          this.ManejarExcepcion(e);
        });
    },
    EnviarACoreAdicionales(prospectoId, tipoFigura) {
      if (tipoFigura == 4 || tipoFigura == 5) {
        axios
          .post(rutaEnviarACoreAdicionales + "/?prospectoId=" + prospectoId)
          .then((resp) => {
            if (resp.data.estado === 0) {
              this.adicionalesEnviadosCore++;
            } else if (resp.data.estado === 1) {
              this.AlertaEmbajadores(resp.data.mensaje, true);
              this.adicionalesEnviadosCore--;
            }
          })
          .catch((e) => {
            this.ManejarExcepcion(e);
            return false;
          });
      }
      this.adicionalesEnviadosCore++;
    },
    async EnviarACore() {
      await axios
        .post(
          rutaEnviarACore +
            "/?prospectoId=" +
            this.ProspectoId +
            "&solicitudId=" +
            this.datosSolicitud.solicitudId +
            "&aplicacionId=0" +
            "&modoPago=" +
            this.modoPago
        )
        .then((resp) => {
          if (resp.data.estado === 0) {
            this.$store.commit("setModoPago", null);
            this.AlertaEmbajadores(resp.data.mensaje, true);
            if (this.tipoUsuario === 3)
              this.$router.push({ path: "SeguimientoProspecto" });
            else this.$router.push({ path: "AdministracionDeProspectos" });
          } else if (resp.data.estado === 1) {
            this.confirmandoDatos = false;
            this.$fire({
              title: "Notice",
              text: resp.data.mensaje,
              showConfirmButton: true,
              showCancelButton: false,
              confirmButtonText: "Accept",
              allowOutsideClick: false,
            }).then((result) => {
              if (result.value) {
                if (this.tipoUsuario === 3)
                  this.$router.push({ path: "SeguimientoProspecto" });
                else this.$router.push({ path: "AdministracionDeProspectos" });
              }
            });
            if (this.modoPago == 2) {
              this.confirmandoDatos = false;
              if (this.tipoUsuario === 3)
                this.$router.push({ path: "SeguimientoProspecto" });
              else this.$router.push({ path: "AdministracionDeProspectos" });
            }
          }
        })
        .catch((e) => {
          this.ManejarExcepcion(e);
        });
    },
    ValidarAprobadoresHojaPrueba(tipoUsuario) {
      //pueden aprobar
      /*
        Prospecto Activo = 3
        Administrador = 5
        Master Operativo = 8
        Administrador Comercial = 10
      */
      const aprobadoresHojaPrueba = [3, 5, 8, 10];
      this.PuedeAprobar = aprobadoresHojaPrueba.includes(tipoUsuario);
    },
  },
};
</script>

<style lang="scss">
@import "../../../../../assets/estilos/estilosgenerales.scss";
.principal-hoja-prueba {
  flex-grow: 1;
}

.row-confirmar {
  display: flex !important;
  justify-content: flex-end;
  margin-bottom: 20px !important;
  margin-top: 20px !important;
}
.boton-confirmar {
  text-align: center;
  width: 30% !important;
  height: 50px;
}
</style>
